import React, { memo } from 'react';

import { Box, Fade, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { NoAvailableMessageIcons } from './NoAvailableMessage.constants';

const NoAvailableMessageContent = ({
  message = '',
  Icon = NoAvailableMessageIcons.NO_DATA,
  delay = 500,
  className,
}) => (
  <Box className={clsx('flex flex-col items-center gap-4', className)}>
    <Fade in timeout={delay}>
      <Box>
        <Icon />
      </Box>
    </Fade>
    <Fade in timeout={delay}>
      <Typography color="text.placeholder" variant="regularItalic12">
        {message}
      </Typography>
    </Fade>
  </Box>
);

NoAvailableMessageContent.propTypes = {
  message: PropTypes.string,
  Icon: PropTypes.func,
  delay: PropTypes.number,
};

export default memo(NoAvailableMessageContent);
